<template>
  <div>
    <Home/>
  </div>
</template>

<script>
  import store from '../lib/store';
  import settings from '../settings/cider';
  import Home from '../pages/Home';


  export default {
    name: 'Cider',
    components: {
      Home,
    },
    created() {
      store.set('subscription', settings.subscription);
      store.set('mailing_list', settings.mailing_list);
      store.set('info_url', settings.info_url);
      store.set('title_in_progress', settings.title.in_progress);
      store.set('title_success', settings.title.success);
      store.set('title_subtext', settings.title.subtext);
      store.set('cancel_anytime', settings.cancel_anytime);
      store.set('review_agreement', settings.review.agreement);
      store.set('review_summary', settings.review.summary);
      store.set('review_button_text', settings.review.button_text);
    },
  };

</script>


// WEBPACK FOOTER //
// Cider.vue?2a4632d8